import { render, staticRenderFns } from "./Titulos.vue?vue&type=template&id=5c84366b&scoped=true&"
import script from "./Titulos.vue?vue&type=script&lang=js&"
export * from "./Titulos.vue?vue&type=script&lang=js&"
import style0 from "./Titulos.vue?vue&type=style&index=0&id=5c84366b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c84366b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VCol,VOverlay,VProgressCircular,VRow,VSimpleTable})
